export default __webpack_public_path__ + "static/media/filter.a18fe521.svg";